import { CategoriesResponse, ProductBaseInfo } from '@shopby/shop-sdk'
import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useNavigate } from 'react-router-dom'
import { HomeSectionType, SectionDetailType } from '../../@types/home'
import { getKeywordSearch, getPopSaleCategorySearch, getSectionsDetail } from '../../api/home'
import { postLikeProducts } from '../../api/product'
import { addToWishlist } from '../../js/pixelEvent'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import {
  findObjectsWithValue,
  formatNumberWithTruncation,
  getParsedSessionStorageItem,
  onErrorImg,
  plusComma,
} from '../../js/script'
import { imgURL } from '../../pages/Home'
import ProductCenterModal from '../product/ProductCenterModal'
import { BtnCart } from '../product/ProductItem'
import ProductModal from '../product/ProductModal'
import { useAppContext } from '../provider/AppProvider'
import { useCommonContext } from '../provider/CommonProvider'
import { useMyContext } from '../provider/MyProvider'
import { IconStarOn } from '../svg/IconSvg'

type PropsTypes = {
  el: any
  index: number
  homeModule?: HomeSectionType[]
  categorys: CategoriesResponse | null
  popularKeyword: string[]
}

export default function CategoryRankingTop({ el, index, homeModule, popularKeyword, categorys }: PropsTypes) {
  const [isModal, setIsModal] = useState<boolean>(false)
  const [sectionItem, setSectionItem] = useState<SectionDetailType>() //섹션 정보
  const [items, setItem] = useState<ProductBaseInfo[]>([]) // 진열할 아이템
  const [selectProductNo, setSelectProductNo] = useState<string>() //선택한 상품 넘버
  const { isAppView } = useAppContext()

  //상품 상세 가져오기
  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        res.data.map((el: any) => {
          setSectionItem(el)
        })
      })
      .catch((err) => console.log(err))
  }, [])
  // 모듈 이름별로 가져오는 기능
  useEffect(() => {
    if (sectionItem?.label === '조회수 TOP4 모듈') {
      getPopSaleCategorySearch('MD_RECOMMEND')
        .then((res) => {
          setItem(res.data.items)
        })
        .catch((err) => console.log(err))
    } else if (sectionItem?.label === '판매순 TOP4 모듈') {
      const array: any = []
      getPopSaleCategorySearch('SALE_CNT')
        .then((res) => {
          setItem(res.data.items)
        })
        .catch((err) => console.log(err))
    } else if (sectionItem?.label === '검색량 TOP4 모듈') {
      popularKeyword.slice(0, 4).map((el: string) => {
        const array: any = []
        getKeywordSearch('POPULAR', 1, el)
          .then((res) => {
            array.push(res.data.items[0])
            setItem((prev: any) => [...prev, res.data.items[0]])
          })
          .catch((err) => console.log(err))
      })
    }
  }, [sectionItem])

  return (
    <>
      <div
        className='best_ranking'
        style={{ minHeight: isMobile ? '845px' : '648px' }}
        onClick={(): void => {
          const gtmNavigateClick: DataLayerArgs = {
            dataLayer: {
              event: 'select_content',
              event_info: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            },
          }
          if (isAppView) {
            sendSetAppsflyerEvent({
              eventName: 'select_content',
              eventType: {
                content_type: '홈모듈',
                content_id: String(el.sectionNo),
                content_name: el.sectionName,
              },
            })
          } else {
            TagManager.dataLayer(gtmNavigateClick)
          }
        }}
      >
        <div className='home_module_title'>
          <p>{sectionItem?.promotionText}</p>
          <p>
            <strong>{sectionItem?.sectionExplain}</strong>
          </p>
        </div>
        <div className='best_ranking_list' style={{ marginTop: '20px' }}>
          <ul>
            {items?.map((element: any, idx: number) => {
              return (
                <RankingCategoryTopItem
                  el={element}
                  idx={idx}
                  setIsModal={setIsModal}
                  setSelectProductNo={setSelectProductNo}
                  key={idx}
                  listId={el.sectionNo}
                  listName={el.sectionName}
                  category={categorys}
                ></RankingCategoryTopItem>
              )
            })}
          </ul>
        </div>
        {/* <div className='btn_more_wrap'>
        <BtnHomeModuleMore>더보기</BtnHomeModuleMore>
      </div> */}
        {index !== 0 && <hr />}
      </div>
      {isModal &&
        (isMobile ? (
          <ProductModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={items}
            listId={el.sectionNo}
            listName={el.sectionName}
          ></ProductModal>
        ) : (
          <ProductCenterModal
            setIsModal={setIsModal}
            headerText={'옵션선택'}
            selectProductNo={selectProductNo}
            listItem={items}
            listId={el.sectionNo}
            listName={el.sectionName}
          ></ProductCenterModal>
        ))}
    </>
  )
}

function RankingCategoryTopItem({ el, idx, setSelectProductNo, setIsModal, listId, listName, category }: any) {
  const [wish, setWish] = useState(false)
  const [disCountAcc, setDisCountAcc] = useState(0)
  const [categoryNo, setCategoryNo] = useState<any>([])
  const [itemCategory, setItemCategory] = useState<any>([])
  const [categorys, setCategorys] = useState<any>([])
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast } = useMyContext()
  const { setIsLogin } = useCommonContext()
  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (el) {
      const count = formatNumberWithTruncation((el?.salePrice - el?.immediateDiscountAmt) * 0.1)
      setDisCountAcc(Number(count.replaceAll(',', '')))
    }
  }, [el])
  useEffect(() => {
    setWish(el?.liked)
  }, [el])

  useEffect(() => {
    setCategoryNo(el.displayCategoryNos.split('|'))
  }, [el])

  useEffect(() => {
    if (categoryNo && categoryNo.length > 0) {
      const newCategories = categoryNo.reduce((acc: any[], el: any) => {
        const foundItems = findObjectsWithValue(category?.flatCategories, Number(el))
        return [...acc, ...foundItems]
      }, [])

      setItemCategory((prev: any) => [...prev, ...newCategories])
    }
  }, [categoryNo, category])

  useEffect(() => {
    if (itemCategory && itemCategory.length > 0) {
      const filteredCategories = itemCategory.filter((el: any) => el.depth1Label !== '브랜드')

      setCategorys((prev: any) => [...prev, ...filteredCategories])
    }
  }, [itemCategory])

  return (
    <li key={el?.productNo}>
      <div className='item_wrap'>
        {/* 상품 이미지 */}
        <div className='item_img'>
          {/* 품절 */}
          {el?.isSoldOut && (
            <div className='soldout'>
              <img src={`${imgURL}/img_soldout.png`} alt='' />
            </div>
          )}
          {/* 찜하기 */}
          <button
            onClick={() => {
              if (hasAccessToken) {
                let likeItem: { like: string; productNo: string } = {
                  like: '',
                  productNo: '',
                }
                if (wish) {
                  likeItem = { like: 'N', productNo: el.productNo }
                } else {
                  likeItem = { like: 'Y', productNo: el.productNo }
                }

                postLikeProducts(likeItem)
                  .then((res: any) => {
                    if (res.data.length !== 0) {
                      if (res.data[0].like === 'Y') {
                        setIsToast(true)
                        setToastMessage('찜 리스트에 저장되었습니다.')
                        setToastBtnMessage('바로가기')
                        setToastEvent(() => () => {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                            })
                          } else {
                            navigate('/wishList')
                          }
                        })
                        addToWishlist(el.productNo, el.productName, el.salePrice, el.immediateDiscountAmt)
                        const gtmWishItem: DataLayerArgs = {
                          dataLayer: {
                            event: 'add_to_wishlist', // ecommerce 이벤트 중 상품보기 단계
                            ecommerce: {
                              value: el?.salePrice - el?.immediateDiscountAmt,
                              items: [
                                {
                                  item_id: String(el?.productNo),
                                  item_name: el?.productName,
                                  affiliation: '어바웃피싱',
                                  item_list_price: el?.salePrice,
                                  item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
                                  price: el?.salePrice - el?.immediateDiscountAmt,
                                  item_total_discount: el?.immediateDiscountAmt,
                                  discount: 0,
                                  index: idx,
                                  item_brand: el?.brandName,
                                  item_category: categorys[0]?.depth1Label,
                                  item_category2: categorys[0]?.depth2Label,
                                  item_category3: categorys[0]?.depth3Label,
                                  item_list_id: String(listId),
                                  item_list_name: listName,
                                },
                              ],
                            },
                          },
                        }
                        if (isAppView) {
                          sendSetAppsflyerEvent({
                            eventName: 'add_to_wishlist',
                            eventType: {
                              value: el?.salePrice - el?.immediateDiscountAmt,
                              items: [
                                {
                                  item_id: String(el?.productNo),
                                  item_name: el?.productName,
                                  affiliation: '어바웃피싱',
                                  item_list_price: el?.salePrice,
                                  item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
                                  price: el?.salePrice - el?.immediateDiscountAmt,
                                  item_total_discount: el?.immediateDiscountAmt,
                                  discount: 0,
                                  index: idx,
                                  item_brand: el?.brandName,
                                  item_category: categorys[0]?.depth1Label,
                                  item_category2: categorys[0]?.depth2Label,
                                  item_category3: categorys[0]?.depth3Label,
                                  item_list_id: String(listId),
                                  item_list_name: listName,
                                },
                              ],
                            },
                          })
                        } else {
                          TagManager.dataLayer(gtmWishItem)
                        }
                      } else if (res.data[0].like === 'N') {
                        setIsToast(true)
                        setToastMessage('찜 리스트에 제외되었습니다.')
                        setToastBtnMessage('바로가기')
                        setToastEvent(() => () => {
                          if (isAppView) {
                            RNPostMessage(AFWebLinkType.moveToLink, {
                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/wishList`,
                            })
                          } else {
                            navigate('/wishList')
                          }
                        })
                      }
                      setTimeout(() => {
                        setWish((prev: boolean) => !prev)
                      }, 200)
                    }
                  })
                  .catch((err) => console.log(err))
              } else {
                if (!hasAccessToken) {
                  setIsToast(true)
                  setToastMessage('로그인이 필요한 서비스입니다.')
                  setToastBtnMessage('로그인')
                  setToastEvent(() => () => setIsLogin(true))
                }
                const app = getParsedSessionStorageItem('app')
                if (app) {
                  RNPostMessage(AFWebLinkType.onSignInInducement)
                }
              }
              // setWish((prev) => !prev);
            }}
          >
            <img
              src={`${wish ? `${imgURL}/icon_heart_fill.png` : `${imgURL}/icon_heart_outline.png`}`}
              alt='찜하기 아이콘'
            />
          </button>
          {/* 랭킹 플래그, 숫자 */}
          <div className='ranking_flag'>
            <img src={`${imgURL}/icon_flag_rank${idx + 1}.svg`} alt='' />
          </div>
          <div
            onClick={(e): void => {
              e.preventDefault()
              const array: any = []
              const obj: {
                item_id: any
                item_name: any
                affiliation: string
                item_list_price: any
                item_selling_price: number
                price: number
                item_total_discount: any
                discount: number
                index: any
                item_brand: any
                item_category: any
                item_category2: any
                item_category3: any
                item_list_id: any
                item_list_name: any
              } = {
                item_id: String(el?.productNo),
                item_name: el?.productName,
                affiliation: '어바웃피싱',
                item_list_price: el?.salePrice,
                item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
                price: el?.salePrice - el?.immediateDiscountAmt,
                item_total_discount: el?.immediateDiscountAmt,
                discount: 0,
                index: idx,
                item_brand: el?.brandName,
                item_category: categorys[0]?.depth1Label,
                item_category2: categorys[0]?.depth2Label,
                item_category3: categorys[0]?.depth3Label,
                item_list_id: String(listId),
                item_list_name: listName,
              }
              array.push(obj)
              const gtmClickItem: DataLayerArgs = {
                dataLayer: {
                  event: 'select_item', // ecommerce 이벤트 중 상품보기 단계
                  ecommerce: {
                    items: array,
                  },
                },
              }
              if (isAppView) {
                sendSetAppsflyerEvent({
                  eventName: 'select_item',
                  eventType: {
                    items: array,
                  },
                })
              } else {
                TagManager.dataLayer(gtmClickItem)
              }
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${
                    el.productNo
                  }?items=${JSON.stringify(array)}`,
                })
              } else {
                navigate(`/product/${el.productNo}`, {
                  state: { items: array },
                })
              }
            }}
          >
            {/* dim */}
            <div className='dim'></div>
            {/* 이미지 */}
            <img src={el?.imageUrls[0]} alt='' onError={onErrorImg} />
          </div>
        </div>
        {/* 장바구니 버튼 */}
        {el?.isSoldOut ? (
          <BtnCart
            style={{
              width: '100%',
            }}
            onClick={(): void => {
              setIsModal(true)
              setSelectProductNo(el.productNo)
            }}
          >
            재입고 알림
          </BtnCart>
        ) : (
          <BtnCart
            style={{
              width: '100%',
            }}
            onClick={(): void => {
              setIsModal(true)
              setSelectProductNo(el.productNo)
            }}
          >
            <img src={`${imgURL}/icon_cart.png`} alt='' /> 장바구니
          </BtnCart>
        )}
        <div
          style={{ width: '100%' }}
          onClick={(e): void => {
            e.preventDefault()
            const array: any = []
            const obj: {
              item_id: any
              item_name: any
              affiliation: string
              item_list_price: any
              item_selling_price: number
              price: number
              item_total_discount: any
              discount: number
              index: any
              item_brand: any
              item_category: any
              item_category2: any
              item_category3: any
              item_list_id: any
              item_list_name: any
            } = {
              item_id: String(el?.productNo),
              item_name: el?.productName,
              affiliation: '어바웃피싱',
              item_list_price: el?.salePrice,
              item_selling_price: el?.salePrice - el?.immediateDiscountAmt,
              price: el?.salePrice - el?.immediateDiscountAmt,
              item_total_discount: el?.immediateDiscountAmt,
              discount: 0,
              index: idx,
              item_brand: el?.brandName,
              item_category: categorys[0]?.depth1Label,
              item_category2: categorys[0]?.depth2Label,
              item_category3: categorys[0]?.depth3Label,
              item_list_id: String(listId),
              item_list_name: listName,
            }
            array.push(obj)
            const gtmClickItem: DataLayerArgs = {
              dataLayer: {
                event: 'select_item', // ecommerce 이벤트 중 상품보기 단계
                ecommerce: {
                  items: array,
                },
              },
            }
            if (isAppView) {
              sendSetAppsflyerEvent({
                eventName: 'select_item',
                eventType: {
                  items: array,
                },
              })
            } else {
              TagManager.dataLayer(gtmClickItem)
            }
            if (isAppView) {
              RNPostMessage(AFWebLinkType.moveToLink, {
                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${
                  el.productNo
                }?items=${JSON.stringify(array)}`,
              })
            } else {
              navigate(`/product/${el.productNo}`, {
                state: { items: array },
              })
            }
          }}
        >
          {/* 상품 브랜드 및 상품명 */}

          {/* 상품 브랜드명 없으면 노출 안함 */}
          {el?.brandName && <div className='item_brand_title'>{el?.brandName}</div>}
          <div className='item_title'>{el?.productName}</div>

          {Math.floor((el?.immediateDiscountAmt / el?.salePrice) * 100) === 0 ? (
            <>
              {/* 상품 할인 퍼센트, 가격 */}
              <div className='item_sale_wrap'>
                <p className='price'>{plusComma(el?.salePrice - el?.immediateDiscountAmt)}원</p>
              </div>
            </>
          ) : (
            <>
              {/* 상품 원 가격 */}
              <div className='item_origin_price'>{plusComma(el?.salePrice)}원</div>

              {/* 상품 할인 퍼센트, 가격 */}
              <div className='item_sale_wrap'>
                <p className='percent'>{Math.floor((el?.immediateDiscountAmt / el?.salePrice) * 100)}%</p>
                <p className='price'>{plusComma(el?.salePrice - el?.immediateDiscountAmt)}원</p>
              </div>
            </>
          )}

          {/* 상품 최대 혜택가 */}
          {!el?.accumulationUseInfo?.usable && !el.enableCoupons ? null : el?.salePrice -
              el?.immediateDiscountAmt -
              el?.couponDiscountAmt -
              (el?.accumulationInfo.rewardRateOfProduct !== 0 ? el?.accumulationInfo?.amount : 0) -
              (el?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) ===
            Number(el?.salePrice - el?.immediateDiscountAmt) ? null : (
            <div className='item_maximum_benefit'>
              <p className='badge'>회원혜택가</p>
              <>
                <p>
                  {plusComma(
                    el?.salePrice -
                      el?.immediateDiscountAmt -
                      el?.couponDiscountAmt -
                      (el?.accumulationInfo.rewardRateOfProduct !== 0 ? el?.accumulationInfo?.amount : 0) -
                      (el?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0) <
                      0
                      ? 0
                      : el?.salePrice -
                          el?.immediateDiscountAmt -
                          el?.couponDiscountAmt -
                          (el?.accumulationInfo.rewardRateOfProduct !== 0 ? el?.accumulationInfo?.amount : 0) -
                          (el?.accumulationUseInfo?.usable ? Number(disCountAcc) : 0)
                  )}
                  원
                </p>
              </>
            </div>
          )}

          {/* 페이백 적립금 5% + 추가적립금 */}
          {hasAccessToken && el?.accumulationInfo?.amount > 0 && (
            <>
              <div className='save_mileage'>
                <span>
                  {`페이백 적립금 ${el?.accumulationInfo.rewardRateOfProduct}% `}
                  {plusComma(el?.accumulationInfo?.amount)}
                  <span>
                    <img src={`${imgURL}/icon_point.png`} alt='' />
                  </span>
                </span>
              </div>
            </>
          )}

          {/* 별점 */}
          <div className='item_star_rating'>
            <IconStarOn width={isMobile ? 14 : 16} height={isMobile ? 14 : 16} />
            <span className='review_rating'>{el?.reviewRating}</span>
            <span className='review_num'>({el?.totalReviewCount})</span>

            {/* Npay */}
            <div className='npay'>
              <img src={`${imgURL}/icon_npay.png`} alt='Naver Pay' />
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}
